/**
 * Check if two BlockNumbers are equal
 *
 * @param {import('./BlockNumberType.js').BlockNumberType} a
 * @param {import('./BlockNumberType.js').BlockNumberType} b
 * @returns {boolean}
 */
export function equals(a, b) {
	return a === b;
}
